//////// 4.3 EFSchema
const fourThreeSchema = {
  title:
    "4_3 Disposal Services (of solid or liquid waste) Used by an Organization",
  cat: "4_3",
  catName: "cat4",
  normal: {
    title:
      "4_3 Disposal Services (of solid or liquid waste) Used by an Organization",
    cat: "4_3",
    catName: "cat4",
    mode: "Waste",
    progressiveOrderSwitch: {
      by: { level: 3, key: "sourceEFName" },
    },
    fields: [
      ////////Emission Factor標題
      {
        key: "Emission Factor Title",
        level: null,
        type: "title",
        title: "Emission Factor",
      },
      //////// Data Source
      {
        key: "emissionFactorTypeId",
        level: 1,
        type: "select",
        label: "Data Source",
        optionsAPI: "emissionFactorDropdown",
        autoFillNum: 0,
      },
      ////////Emission Factor Database Source
      {
        key: "sourceEFName",
        level: 3,
        type: "select",
        label: "Emission Factor Database Source",
        optionsAPI: "emissionLevel",
        optionsParamFrom: {
          value: "4_3",
        },
        showIf: {
          all: [
            { level: 1, key: "emissionFactorTypeId", ne: "2" },
            { level: 1, key: "emissionFactorTypeId", notEmpty: true },
          ],
        },
        combineKey: 2,
      },
      //////// Waste Treatment Method
      {
        key: "wasteTreatmentMethod",
        level: 4,
        type: "select",
        label: "Waste Treatment Method",
        optionsAPI: "emissionLevel",
        optionsParamFrom: {
          level: 3,
          key: "sourceEFName",
        },
        showIf: { level: 3, key: "sourceEFName", notEmpty: true },
        combineKey: 3,
      },
      //////// Waste Type / Name
      {
        key: "emissionFactorId",
        level: 5,
        type: "select",
        label: "Waste Type / Name",
        optionsAPI: "emissionLevel",
        optionsParamFrom: {
          level: 4,
          key: "wasteTreatmentMethod",
        },
        showIf: { level: 4, key: "wasteTreatmentMethod", notEmpty: true },
        combineKey: 4,
      },
      ////////Emission Factor Name (自定義)
      {
        key: "emissionFactorId",
        addBtn: true,
        level: 5,
        type: "select",
        custom: true,
        label: "Emission Factor Name",
        optionsAPI: "cat4CustomEFDropdownList",
        showIf: {
          level: 1,
          key: "emissionFactorTypeId",
          eq: "2",
        },
        autoFillNum: 0,
      },
    ],
  },
  tran: {
    title:
      "4_3 Disposal Services (of solid or liquid waste) Used by an Organization",
    cat: "4_3",
    catName: "cat4",
    mode: "Transportation",
    progressiveOrderSwitch: {
      by: { level: 3, key: "landSourceEFName" },
    },
    fields: [
      ////////Transportation Emission Factor標題
      {
        key: "Transportation Emission Factor Title",
        level: null,
        type: "title",
        title: "Transportation Emission Factor",
        specialDataShouldIf: {
          level: 1,
          key: "isTransport",
          eq: true,
          formData: "landEAFormData",
        },
      },
      ////////Data Source
      {
        key: "landEFTypeId",
        level: 2,
        type: "select",
        label: "Data Source",
        optionsAPI: "emissionFactorDropdown",
        optionsParamFrom: {
          value: "4_3",
        },
        autoFillNum: 0,
        specialDataShouldIf: {
          level: 1,
          key: "isTransport",
          eq: true,
          formData: "landEAFormData",
        },
      },
      ////////Emission Factor Database Source
      {
        key: "landSourceEFName",
        level: 3,
        type: "select",
        label: "Emission Factor Database Source",
        optionsAPI: "emissionLevel",
        optionsParamFrom: {
          level: 2,
          key: "landEFTypeId",
        },
        specialDataShouldIf: {
          level: 1,
          key: "isTransport",
          eq: true,
          formData: "landEAFormData",
        },
        showIf: {
          level: 2,
          key: "landEFTypeId",
          eq: 1,
        },
        combineKey: 2,
      },
      ////////Vehicle Category
      {
        key: "vehicleCategory",
        level: 4,
        type: "select",
        label: "Vehicle Category",
        optionsAPI: "emissionLevel",
        optionsParamFrom: {
          level: 3,
          key: "landSourceEFName",
        },
        showIf: { level: 3, key: "landSourceEFName", notEmpty: true },
        combineKey: 3,
      },
      ////////Vehicle Type
      {
        key: "landEFId",
        level: 5,
        type: "select",
        label: "Vehicle Type",
        optionsAPI: "emissionLevel",
        optionsParamFrom: {
          level: 4,
          key: "vehicleCategory",
        },
        showIf: { level: 4, key: "vehicleCategory", notEmpty: true },
        combineKey: 4,
      },
      ////////Emission Factor Name (自定義)
      {
        key: "landEFId",
        addBtn: true,
        level: 5,
        type: "select",
        custom: true,
        label: "Emission Factor Name",
        optionsAPI: "cat4CustomEFDropdownList",
        showIf: {
          level: 2,
          key: "landEFTypeId",
          eq: "2",
        },
        autoFillNum: 0,
      },
    ],
  },
};

export default fourThreeSchema;
